export default __webpack_public_path__ + "static/media/performancetesting.fa63c425.png";